import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AcordoJuridicoService } from 'src/app/services/acordo-juridico.service';
import { ProcessosJudiciaisService } from 'src/app/services/processos-judiciais.service';
import { ModalCadastrarAcordoJudicialComponent } from './modal-cadastrar-acordo-judicial/modal-cadastrar-acordo-judicial.component';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalCadastrarAcordoJudicialService {

    constructor(
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        public modalService: NgbModal,        
        private acordoJuridicoService: AcordoJuridicoService,
        private processosJudiciaisService: ProcessosJudiciaisService,
    ) { }

    private acordoConcluidoSubject = new Subject<any>();
    acordoConcluido$ = this.acordoConcluidoSubject.asObservable();

    abrirModalCadastrarAcordo(acordo: any): Promise<NgbModalRef> {
        this.spinner.show();
    
        return new Promise((resolve, reject) => {
            this.acordoJuridicoService.obterAcordosPorReferencia(acordo.referenciaId).subscribe({
                next: res => {
                    const acordos = res.data;
                    debugger;
                    this.processosJudiciaisService.obterTaxasAcordo(acordo.idProcesso).subscribe({
                        next: res => {
                            const taxasAcordo = res.data;
                            let tipoAcordo = 3;
                            let acordoRenegociacaoId = acordos.find(x => x.tipoAcordoJudicial != "Honorário")?.id;
                            let acordoHonorarioRenegociacaoId = acordos.find(x => x.tipoAcordoJudicial == "Honorário")?.id;
    
                            tipoAcordo = acordos.length == 2
                                ? 5
                                : (acordos.find(x => x.tipoAcordoJudicial == "Honorário") ? 4 : 3);
    
                            const modalRef = this.modalService.open(ModalCadastrarAcordoJudicialComponent, {
                                size: tipoAcordo === 0 || tipoAcordo === 5 ? 'lg' : 'md',
                                backdrop: 'static',
                                keyboard: false
                            });
    
                            modalRef.componentInstance.modalRef = modalRef;
                            modalRef.componentInstance.processoJudicialId = acordo.idProcesso;
                            modalRef.componentInstance.recursoDesdobramentoId = acordo.idRecursoDesdobramento;
                            modalRef.componentInstance.taxasAcordo = taxasAcordo;
                            modalRef.componentInstance.pessoaId = acordo.clienteId;
                            modalRef.componentInstance.tipoAcordo = tipoAcordo;
    
                            if ((tipoAcordo === 3 || tipoAcordo === 4 || tipoAcordo === 5) && !acordo.AcordoRenegociado) {
                                this.acordoJuridicoService.obterValorEmAbertoAcordoDescumprido(acordoRenegociacaoId || acordoHonorarioRenegociacaoId)
                                    .subscribe({
                                        next: res => {
                                            debugger;
                                            const data = res.data;
                                            if (tipoAcordo === 3 || tipoAcordo === 5) {
                                                modalRef.componentInstance.camposSimulacao = {
                                                    ...modalRef.componentInstance.camposSimulacao,
                                                    valorAvulso: data.filter(f=>f.principal)[0].valorAberto,
                                                    valorConfessado: data.filter(f=>f.principal)[0].valorAberto,
                                                    tipoAcordo: tipoAcordo.toString(),
                                                    acordoRenegociacaoId
                                                };
    
                                                if (tipoAcordo === 5) {
                                                    modalRef.componentInstance.camposSimulacaoHonorario = {
                                                        ...modalRef.componentInstance.camposSimulacaoHonorario,
                                                        valorAvulso: data.filter(f=>!f.principal)[0].valorAberto,
                                                        valorConfessado: data.filter(f=>!f.principal)[0].valorAberto,
                                                        tipoAcordo: tipoAcordo.toString(),
                                                        acordoRenegociacaoId: acordoHonorarioRenegociacaoId
                                                    };
                                                }
                                            } else {
                                                modalRef.componentInstance.camposSimulacaoHonorario = {
                                                    ...modalRef.componentInstance.camposSimulacaoHonorario,
                                                    valorAvulso: data[0].valorAberto,
                                                    tipoAcordo: tipoAcordo.toString(),
                                                    acordoRenegociacaoId: acordoHonorarioRenegociacaoId
                                                };
                                            }
    
                                            this.spinner.hide();
                                            resolve(modalRef);
                                        },
                                        error: err => {
                                            this.toastrService.error('Erro ao carregar valores do acordo descumprido', 'Erro');
                                            modalRef.dismiss();
                                            this.spinner.hide();
                                            reject(err);
                                        }
                                    });
                            } else {
                                this.spinner.hide();
                                resolve(modalRef);
                            }
                        },
                        error: err => {
                            this.spinner.hide();
                            this.toastrService.error('Erro ao carregar taxas', 'Erro');
                            reject(err);
                        }
                    });
                },
                error: err => {
                    this.spinner.hide();
                    this.toastrService.error('Erro ao carregar acordos', 'Erro');
                    reject(err);
                }
            });
        });
    }
}
